var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgUtilityIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 19,
    viewBox: "0 0 24 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.24992 2.41667C2.24992 1.22005 3.21997 0.25 4.41658 0.25H13.0833C14.2799 0.25 15.2499 1.22005 15.2499 2.41667V4.58333H19.5833C20.7799 4.58333 21.7499 5.55338 21.7499 6.75V16.5H22.8333C23.4316 16.5 23.9166 16.985 23.9166 17.5833C23.9166 18.1816 23.4316 18.6667 22.8333 18.6667H1.16659C0.568277 18.6667 0.083252 18.1816 0.083252 17.5833C0.083252 16.985 0.568277 16.5 1.16659 16.5H2.24992V2.41667ZM15.2499 16.5H19.5833V6.75H15.2499V16.5ZM6.58325 6.75C6.58325 6.15169 7.06828 5.66667 7.66658 5.66667H9.83325C10.4316 5.66667 10.9166 6.15169 10.9166 6.75C10.9166 7.34831 10.4316 7.83333 9.83325 7.83333H7.66658C7.06828 7.83333 6.58325 7.34831 6.58325 6.75ZM6.58325 11.0833C6.58325 10.485 7.06828 10 7.66658 10H9.83325C10.4316 10 10.9166 10.485 10.9166 11.0833C10.9166 11.6816 10.4316 12.1667 9.83325 12.1667H7.66658C7.06828 12.1667 6.58325 11.6816 6.58325 11.0833Z",
    fill: "#171717",
    fillOpacity: 0.8
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUtilityIcon);
export default __webpack_public_path__ + "static/media/utility-icon.31fd639a223359249fc64ade0fbbe3db.svg";
export { ForwardRef as ReactComponent };